import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../../services/api';

/**
 * Wraps dashboard routes. On mount, fetches verification state.
 * - If verified → render children.
 * - If not verified → redirect to the verification wizard.
 */
const RequireVerified = ({ children }) => {
  const [state, setState] = useState('loading'); // 'loading' | 'verified' | 'unverified'

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await api.get('/fintech/verification');
        if (!alive) return;
        setState(res.data.verified ? 'verified' : 'unverified');
      } catch (err) {
        console.error(err);
        if (alive) setState('unverified');
      }
    })();
    return () => { alive = false; };
  }, []);

  if (state === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center text-[14px] text-gray-500">
        Loading…
      </div>
    );
  }

  if (state === 'unverified') {
    return <Navigate to="/fintech/verification" replace />;
  }

  return children;
};

export default RequireVerified;